import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { updateProfile } from "api/User";
import { UserContext } from "context/user";
import Button from "components/Button";
import CheckBox from "components/CheckBox";
import termsAndCondition from "assets/images/datafarming-terms-and-condition.pdf";
import privacyPolicy from "assets/images/datafarming-collection-notice.pdf";
import "./index.scss";
import { toast } from "react-toastify";

const TermsAndConditionContainer = () => {
  const history = useHistory();
  const { token, profile } = useContext(UserContext);
  const [isTermsAndConditionChecked, setTermsAndConditionChecked] =
    useState(false);
  const [isPrivacyPolicyChecked, setPrivacyPolicyChecked] = useState(false);

  useEffect(() => {
    if (profile?.account?.terms_accepted_version) {
      history.push("/dashboard");
    }
  }, [history, profile]);

  const handleStart = async () => {
    try {
      const data = {
        terms_accepted_version: "v1",
      };
      const response = await updateProfile(data, token);
      if ([204, 200, 201].includes(response.status)) {
        toast.success("Redirecting to Dashboard..");
      }
    } catch (e) {
      toast.error("Something went wrong! Redirecting to Dashboard..");
    }

    const delay = setTimeout(() => {
      history.push("/dashboard");
      window.clearTimeout(delay);
    }, 3000);
  };
  return (
    <div data-testid="terms-and-conditions" className="terms-and-condition">
      <div className="terms-container">
        <p className="header">Hello there!</p>
        <p className="details">
          As we transition to our new Datafarming website. We advise that you
          read and agree with our new terms & conditions, and privacy policy.
        </p>
        <div data-testid="terms-and-conditions-toggle" className="toggle">
          <CheckBox
            checked={isTermsAndConditionChecked}
            onChange={() =>
              setTermsAndConditionChecked((prevState) => !prevState)
            }
          />
          <p>
            I agree with the new Datafarming{" "}
            <a
              className="link"
              href={termsAndCondition}
              target="_blank"
              rel="noreferrer"
            >
              Terms and Conditions.
            </a>
          </p>
        </div>
        <div data-testid="privacy-policy-toggle" className="toggle">
          <CheckBox
            checked={isPrivacyPolicyChecked}
            onChange={() => setPrivacyPolicyChecked((prevState) => !prevState)}
          />
          <p>
            I agree with the new Datafarming{" "}
            <a
              className="link"
              href={privacyPolicy}
              target="_blank"
              rel="noreferrer"
            >
              Information Collection Notice.
            </a>
          </p>
        </div>
        <Button
          onClick={() => handleStart()}
          label="Start using DataFarming"
          type="solid"
          color="blue"
          disabled={!isTermsAndConditionChecked || !isPrivacyPolicyChecked}
        />
      </div>
    </div>
  );
};
export default TermsAndConditionContainer;
